import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-banorte',
  templateUrl: './loader-banorte.component.html',
  styleUrls: ['./loader-banorte.component.scss']
})
export class LoaderBanorteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
